import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core'; // Added ChangeDetectorRef
import { Functions } from '@angular/fire/functions'; // Updated Functions
import { Config } from 'src/app/_models/config';
import { Auth } from '@angular/fire/auth'; // Updated Auth
import { Storage, ref, getDownloadURL, uploadBytes } from '@angular/fire/storage'; // Updated Storage
import { Firestore, doc, docData, setDoc, DocumentReference } from '@angular/fire/firestore'; // Updated Firestore
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-super-admin-layout',
  templateUrl: './super-admin-layout.component.html',
  styleUrls: ['./super-admin-layout.component.scss']
})
export class SuperAdminLayoutComponent implements OnInit {

  public config: Config;

  attachments: any[] = [];
  public maxContent = 1;
  maxImageSize: number = 10000000;
  public _reload = true;
  public downloadURL : string | undefined; // Changed type from Observable<string>

  @ViewChild('email') emailInput : ElementRef;

  constructor(private functions: Functions, // Updated injection
              private firestore: Firestore, // Updated injection
              private storage: Storage, // Updated injection
              public auth: Auth, // Updated injection
              private cdr: ChangeDetectorRef) { // Added ChangeDetectorRef
    //if(!environment.production)
    // {
    //   this.firebaseFunctions.useFunctionsEmulator('http://localhost:5001');
    // }

    const configDocRef = doc(this.firestore, "config/Config") as DocumentReference<Config>; // Create typed doc ref
    docData(configDocRef).pipe(map(async (value) => { // Use docData
      if(value === undefined) {
        let config = new Config();
        this.config = config;
        // Convert class instance to plain object for setDoc
        const plainConfigObject = JSON.parse(JSON.stringify(config));
        await setDoc(configDocRef, plainConfigObject); // Use setDoc, await if needed
      }
      else {
        this.config = value as Config; // Cast Firestore data to local Config type
      }

      const filePath = this.config?.image; // Use optional chaining
      if(filePath !== undefined) {
         try {
            const storageRef = ref(this.storage, filePath); // Use modular ref
            this.downloadURL = await getDownloadURL(storageRef); // Use modular getDownloadURL
            this.cdr.detectChanges(); // Trigger change detection
          } catch (error) {
            console.error("Error getting logo URL:", error);
            this.downloadURL = undefined;
          }
      } else {
         this.downloadURL = undefined;
      }
    })).subscribe();
  }

  ngOnInit(): void {
    
  }

  public save() {
    const configDocRef = doc(this.firestore, "config/Config") as DocumentReference<Config>; // Create typed doc ref
    // Convert class instance to plain object for setDoc
    const plainConfigObject = JSON.parse(JSON.stringify(this.config));
    setDoc(configDocRef, plainConfigObject) // Use setDoc
      .then(() => console.log("Config saved"))
      .catch(error => console.error("Error saving config:", error));
  }

  public onFilesSelect(event: any)
  {
    let files = [...event.files];
    //this.attachmentsError.nativeElement.innerHTML = null;

    files.forEach(file => {
      var type = this.getFileType(file);
      if(type === "image" && file.size < this.maxImageSize) {

        this.attachments.push({
          name: file.name,
          url: file.objectURL,
          size: file.size,
          isUploaded: false,
          type: type,
          file: file
        });

        this.uploadFiles(this.attachments);
      }
      else {
        console.error("Nope");
        //this.attachmentsError.nativeElement.innerHTML = "<p>File size exceeded</p>";
      }
    });

    this.reload();
  }

  private getFileType(file: any) {
    switch (file.name.substring(file.name.lastIndexOf('.')+1)) {
      case 'mp4':
      case 'mov':
      case 'avi':
      case 'mpg':
      case 'mkv':
        return "video";
      default:
        return "image";
    }
  }

  private reload() {
      setTimeout(() => this._reload = false);
      setTimeout(() => this._reload = true);
  }

  private uploadFiles(attachments: any[]) : void
  {
    attachments.forEach((attachment)=> {
      if(attachment.type === 'image' && attachment.isUploaded === false)
      {
        // Keep original filename but ensure safe characters if needed, or generate unique name
        const safeFileName = attachment.name.replace(/[^a-zA-Z0-9.]/g, '_'); // Basic sanitization
        const filePath = `config/${safeFileName}`; // Use sanitized/original name
        this.config.image = filePath; // Update config with the path
        const storageRef = ref(this.storage, filePath); // Use modular ref
        // Determine content type more reliably
        const contentType = attachment.file.type || 'application/octet-stream'; // Get from file or default
        uploadBytes(storageRef, attachment.file, { contentType: contentType }) // Use uploadBytes
          .then(async (snapshot) => {
            console.log('Uploaded config image!', snapshot);
            // Optionally update downloadURL immediately after upload
            this.downloadURL = await getDownloadURL(storageRef);
            this.save(); // Save the config with the updated image path
            this.cdr.detectChanges(); // Trigger change detection
          })
          .catch(error => {
            console.error("Error uploading config image:", error);
            // Handle error
          });
      }
    });
  }
}
